var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEarly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.894 71.1581C140.894 109.593 109.749 140.738 71.3144 140.738C32.8797 140.738 1.73438 109.593 1.73438 71.1581C1.73438 32.7235 32.8797 1.57812 71.3144 1.57812C109.749 1.57812 140.894 32.7235 140.894 71.1581Z",
    fill: "url(#paint0_linear_1545_9253)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9253)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.3153,
    cy: 71.1581,
    r: 61.3872,
    stroke: "#98A2B3",
    strokeWidth: 4.07895
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5819 24.5947L52.5666 28.4015C52.4919 28.5508 52.38 28.6254 52.1934 28.6628L47.9387 29.4092C46.7817 29.5958 45.8114 30.4542 45.4382 31.5738C45.0649 32.6935 45.3635 33.9251 46.1846 34.7835L49.1703 37.8812C49.2823 37.9932 49.3196 38.1424 49.3196 38.2917L48.7225 42.5464C48.5358 43.7033 49.0584 44.8976 49.9914 45.6067C50.9617 46.3159 52.2307 46.4278 53.2757 45.9053L57.1571 44.0019C57.3064 43.9273 57.4557 43.9273 57.605 44.0019L61.4864 45.9053C62.5687 46.4278 63.8004 46.3159 64.7707 45.6067C65.7411 44.8976 66.2263 43.7407 66.0396 42.5464L65.4425 38.2917C65.4052 38.1424 65.4798 37.9932 65.5918 37.8812L68.5775 34.7835C69.3986 33.9251 69.6972 32.6935 69.3239 31.5738C68.9507 30.4542 67.9804 29.5958 66.8234 29.4092L62.5687 28.6628C62.4195 28.6254 62.2702 28.5508 62.1955 28.4015L60.1802 24.5947C59.6203 23.5497 58.538 22.8779 57.3437 22.8779C56.2241 22.8779 55.1418 23.5124 54.5819 24.5947Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0976 24.5947L80.0822 28.4015C80.0076 28.5508 79.8956 28.6254 79.709 28.6628L75.4543 29.4092C74.2974 29.5958 73.327 30.4542 72.9538 31.5738C72.5806 32.6935 72.8791 33.9251 73.7002 34.7835L76.6859 37.8812C76.7979 37.9932 76.8352 38.1424 76.8352 38.2917L76.2381 42.5464C76.0515 43.7033 76.574 44.8976 77.507 45.6067C78.4774 46.3159 79.7463 46.4278 80.7913 45.9053L84.6727 44.0019C84.822 43.9273 84.9713 43.9273 85.1206 44.0019L89.002 45.9053C90.0844 46.4278 91.316 46.3159 92.2863 45.6067C93.2567 44.8976 93.7419 43.7407 93.5553 42.5464L92.9581 38.2917C92.9208 38.1424 92.9954 37.9932 93.1074 37.8812L96.0931 34.7835C96.9142 33.9251 97.2128 32.6935 96.8396 31.5738C96.4663 30.4542 95.496 29.5958 94.339 29.4092L90.0844 28.6628C89.9351 28.6254 89.7858 28.5508 89.7112 28.4015L87.6958 24.5947C87.136 23.5497 86.0536 22.8779 84.8594 22.8779C83.7397 22.8779 82.6574 23.5124 82.0976 24.5947Z",
    fill: "#98A2B3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1545_9253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.34 85.5403C104.34 88.2274 102.512 90.2055 100.869 91.9222C99.9737 92.8553 99.078 93.8256 98.8541 94.5347C98.6157 95.2839 98.7502 96.4679 98.889 97.6901L98.8893 97.6927C98.9025 97.8092 98.9157 97.9261 98.9287 98.043C99.2273 100.357 99.5259 103.007 98.033 105.097C96.4767 107.209 93.9271 107.702 91.6261 108.147L91.5764 108.157C91.5058 108.172 91.435 108.186 91.364 108.2C91.2887 108.216 91.2133 108.231 91.1379 108.246C90.0085 108.473 88.8911 108.698 88.3294 109.127C87.7252 109.554 87.1209 110.658 86.5167 111.761L86.426 111.927C85.3437 114.017 84.0374 116.368 81.5369 117.189C80.9771 117.376 80.3799 117.45 79.8201 117.45C78.0742 117.45 76.3962 116.668 74.8513 115.947L74.6324 115.845C73.4381 115.248 72.1692 114.651 71.3108 114.651C70.4524 114.651 69.2208 115.248 67.9892 115.845C65.8992 116.853 63.5106 117.973 61.0847 117.189C58.5842 116.368 57.3152 114.017 56.1956 111.927L56.105 111.761C55.5007 110.658 54.8964 109.554 54.2922 109.127C53.6577 108.642 52.3515 108.381 51.0452 108.157L50.9693 108.142C48.6744 107.698 46.1021 107.201 44.5886 105.097C43.0584 103.007 43.3943 100.357 43.6929 98.043C43.7048 97.9355 43.717 97.8278 43.7292 97.7202L43.7292 97.72L43.7292 97.7199C43.8692 96.4821 44.0078 95.2558 43.7675 94.5347C43.5613 93.8817 42.7537 93.0071 41.9568 92.1442L41.9553 92.1425C41.8874 92.069 41.8195 91.9955 41.7522 91.9222L41.7199 91.8878C40.1225 90.179 38.2812 88.2094 38.2812 85.5403C38.2812 82.8531 40.11 80.8751 41.7522 79.1583C41.8198 79.0848 41.8879 79.011 41.9561 78.9372L41.9567 78.9365L41.9568 78.9364C42.7537 78.0734 43.5613 77.1988 43.7675 76.5458C44.0059 75.7967 43.8714 74.6126 43.7327 73.3904C43.7193 73.273 43.706 73.1553 43.6929 73.0375C43.3943 70.7236 43.0957 68.0738 44.5886 65.9838C46.1449 63.8717 48.6945 63.3783 50.9955 62.933L51.0452 62.9234C51.1907 62.8935 51.3372 62.864 51.4835 62.8346L51.4837 62.8345L51.4837 62.8345C52.6131 62.6073 53.7305 62.3826 54.2922 61.9531C54.8964 61.5265 55.5007 60.423 56.1049 59.3194L56.1956 59.1539C57.2779 57.0639 58.5842 54.7127 61.0847 53.8916C63.4346 53.0962 65.7146 54.157 67.7548 55.1062L67.9519 55.1979C69.1462 55.795 70.4151 56.3921 71.2735 56.3921C72.127 56.3921 73.3863 55.8018 74.5746 55.2448L74.5951 55.2352C76.6851 54.2275 79.0737 53.1079 81.4996 53.8916C84.0374 54.7127 85.3064 57.0639 86.426 59.1539L86.5167 59.3194C87.1209 60.423 87.7252 61.5265 88.3294 61.9531C88.9639 62.4382 90.2701 62.6995 91.5764 62.9234L91.6523 62.9381C93.9473 63.3821 96.5195 63.8797 98.033 65.9838C99.5632 68.0738 99.2273 70.7236 98.9287 73.0375L98.9096 73.2084L98.8924 73.3607C98.7524 74.5984 98.6138 75.8248 98.8541 76.5458C99.0603 77.1988 99.8679 78.0734 100.665 78.9363L100.665 78.9364C100.733 79.0105 100.802 79.0845 100.869 79.1583L100.902 79.1928C102.499 80.9016 104.34 82.8711 104.34 85.5403ZM76.3101 80.0541C76.3101 81.323 75.3024 82.3307 74.0335 82.3307L69.7041 82.2934V83.2264H71.2717C72.5406 83.2264 73.5483 84.2341 73.5483 85.503C73.5483 86.772 72.5406 87.7796 71.2717 87.7796H69.7041V88.7127H74.0335C75.3024 88.7127 76.3101 89.7204 76.3101 90.9893C76.3101 92.2582 75.3024 93.2659 74.0335 93.2659H67.4649C66.1959 93.2659 65.1882 92.2582 65.1882 90.9893V80.0541C65.1882 78.7852 66.1959 77.7775 67.4649 77.7775H74.0335C75.3024 77.7775 76.3101 78.7852 76.3101 80.0541ZM60.8966 77.8149C59.6277 77.8149 58.62 78.8226 58.62 80.0915V82.8533L56.2687 78.9346C55.7462 78.0762 54.7012 77.6283 53.7309 77.9269C52.7605 78.1881 52.0514 79.0839 52.0514 80.1289V91.0641C52.0514 92.333 53.0591 93.3407 54.328 93.3407C55.5969 93.3407 56.6046 92.333 56.6046 91.0641V88.3023L58.9559 92.221C59.3664 92.9301 60.1128 93.3407 60.8966 93.3407C61.0832 93.3407 61.3071 93.3034 61.4937 93.266C62.4641 93.0048 63.1732 92.1091 63.1732 91.0641V80.1289C63.1732 78.8226 62.1655 77.8149 60.8966 77.8149ZM86.014 80.0915C86.014 78.8226 87.0217 77.8149 88.2906 77.8149C89.5596 77.8149 90.5672 78.8226 90.4926 80.0915V91.0267C90.4926 91.9971 89.8955 92.8928 88.9624 93.1914C88.7385 93.266 88.4772 93.3034 88.2533 93.3034C87.5815 93.3034 86.9097 92.9675 86.4619 92.4076L83.8867 89.0114L81.3115 92.4076C80.7144 93.1914 79.7067 93.5273 78.7736 93.1914C77.8779 92.8555 77.2435 91.9971 77.2435 91.0267V80.0915C77.2435 78.8226 78.2511 77.8149 79.5201 77.8149C80.789 77.8149 81.7967 78.8226 81.7967 80.0915V84.3089L82.0953 83.8983C82.9537 82.7787 84.8571 82.7787 85.7154 83.8983L86.014 84.3089V80.0915Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9253",
    x: 7.88867,
    y: 7.73145,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9253",
    x: 45.2793,
    y: 22.8779,
    width: 51.7188,
    height: 24.9841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1545_9253",
    x: 38.2812,
    y: 53.6123,
    width: 66.0586,
    height: 65.4714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9253",
    x1: 23.0344,
    y1: 16.7248,
    x2: 124.564,
    y2: 115.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEarly);
export default __webpack_public_path__ + "static/media/IconEarly.3a1a591046685c2fc3646b7b37dde0e7.svg";
export { ForwardRef as ReactComponent };